
import { Component, Vue } from "vue-property-decorator";
import InputAid from "./components/InputAid.vue";

@Component({
  components: {
    InputAid,
  },
})
export default class App extends Vue {
  public sharedId: string = "";

  created() {
    console.log(window.location.pathname);
    const route = window.location.pathname;
    const match = route.match(/\/_share\/([^/]+)/);
    console.log(match);
    if (match) {
      this.sharedId = match[1];
    }
    window.history.replaceState(null, "Qantuppi", "/");
  }
}
